import React, { useEffect } from "react";
import styles from "../styles/components/DropdownCharacterList.module.css";
import common from "../styles/Common.module.css";

import useApi from "../hooks/useApi";
import MyCharactersGridItem from "./MyCharactersGridItem";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCharacters, updateCharacter } from "../reducers/characterSlice";

import plusIcon from "../images/plus-icon.svg";

const DropdownCharacterList = ({ updateMenu }) => {
  const { get } = useApi();
  const navigate = useNavigate();
  const { id } = useParams();

  const dispatch = useDispatch();
  const characters = useSelector((state) => state.characters.items);
  const status = useSelector((state) => state.characters.status);

  useEffect(() => {
    if (status === "idle") {
      dispatch(getCharacters({get}));
    }
  }, [status, dispatch]);

  const goToCharacter = (character = null) => {
    if (character) navigate(`/character/${character.id}`, { replace: true });
    else navigate(`/character/`, { replace: true });

    // updateMenu(0);
  };

  return (
    <div className={styles.dropdown}>
      <div className={styles.menuContent}>
        <div className={styles.topControl}></div>

        {characters == null ? (
          <div className={styles.loader}></div>
        ) : (
          <div className={styles.gridContainer}>
            <button
              className={common.addButton}
              onClick={() => goToCharacter(null)}
            >
              <img src={plusIcon} />
            </button>

            {characters.slice().map((item) => (
              <MyCharactersGridItem
                key={item.id}
                item={item}
                selected={parseInt(id) === item.id}
                onClick={() => goToCharacter(item)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DropdownCharacterList;
